module.exports = __webpack_public_path__ + "front/img/kv01.f51584ab.png";